import merge from 'deepmerge';
import i18n from 'i18next';
/**
 * Currently, we use only 'en-GB' or the list of languages from
 * the config file (the header menu controls)
 */
// import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import find from 'lodash/find';
import { initReactI18next } from 'react-i18next';

export default function initI18n(options = {}, source, publicPath) {
  const { xhr: xhrOptions = {}, ...otherOptions } = options;

  const xhr = new HttpApi(null, {
    loadPath: xhrOptions.loadPath || `${publicPath || ''}locales/{{lng}}/{{ns}}.json`,
    parse(data) {
      const parsedData = JSON.parse(data);
      const sourceData = parsedData.sources
        ? find(parsedData.sources, item => item.source === source)
        : null;

      if (sourceData) {
        return merge(parsedData, sourceData);
      }

      return parsedData;
    },
    ...xhrOptions
  });

  i18n
    // load translation using xhr -> see /locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(xhr)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      load: 'currentOnly',
      defaultLanguage: 'en-GB',
      fallbackLng: ['en-GB'],
      whitelist: ['en-GB', 'es', 'fr'],
      fallbackNS: 'translation',
      ...otherOptions,
      debug: false,
      interpolation: {
        escapeValue: false // not needed for react as it escapes by default
      },
      react: {
        useSuspense: false
      }
    });
}
